import { CLASSIFICATION_CATEGORIES, CLASSIFICATION_SECTIONS } from 'sh-www/models/classification';

export function mapClassificationsToCategories(classifications) {
  const classificationItems = {
    [CLASSIFICATION_SECTIONS.SUBJECT]: [],
    [CLASSIFICATION_SECTIONS.MEDIUM]: [],
    [CLASSIFICATION_SECTIONS.INDUSTRY]: [],
  };

  if (!classifications || classifications.length < 1) {
    return classificationItems;
  }

  classifications.forEach(classification => {
    if (classification.category === CLASSIFICATION_CATEGORIES.CATEGORY_SUBJECT) {
      classificationItems[CLASSIFICATION_SECTIONS.SUBJECT].push(classification);
    }
    if (classification.category === CLASSIFICATION_CATEGORIES.CATEGORY_MEDIUM) {
      classificationItems[CLASSIFICATION_SECTIONS.MEDIUM].push(classification);
    }
    if (classification.category === CLASSIFICATION_CATEGORIES.CATEGORY_INDUSTRY) {
      classificationItems[CLASSIFICATION_SECTIONS.INDUSTRY].push(classification);
    }
  });

  return classificationItems;
}

export function getClassificationIdsFromObject(classifications) {
  return Object.keys(classifications).reduce((ids, category) => {
    classifications[category].forEach(classification => {
      ids.push(classification.id);
    })
    return ids;
  }, []);
}
